import BaseModel from '../base';
import QuestionTag from './tag/index';
import AnswerOption from '../answer/option/index';
import Criterian from '../criterian/index';

import constants from './constants';
import glossary from './glossary';

export default class Question extends BaseModel {
  constructor(question = {}, url) {
    super(question, url);

    this.name = question.name;
    this.description = question.description;
    this.type = question.type;
    this.sort_order = question.sort_order;
    this.settings = question.settings;
    this.event_poll_id = question.event_poll_id;

    this.options = Question.serializeOptions(
      (question.options || []).map((i) => new AnswerOption(i, 'option')),
    );

    this.criterias = (question.criterias || [])
      .map((i) => new Criterian(i, 'criterian'));

    this.tag = question.tag ? new QuestionTag(question.tag) : null;
  }

  get displayType() {
    const { type } = this;
    const { QUESTION_TYPES_DATA } = glossary;

    return QUESTION_TYPES_DATA[type];
  }

  get maxPoints() {
    const { calcMaxPoints } = this.displayType;
    return calcMaxPoints(this);
  }

  get outputOptions() {
    return this.options.reduce((acc, option) => {
      if (option.pair) {
        const newOption = new AnswerOption({
          ...option.pair,
          parent_id: option.id,
        });

        acc.push(newOption);
      }

      return [...acc, option];
    }, []);
  }

  static serializeOptions(options = []) {
    return options
      .reduce((acc, option) => {
        if (option.hasParent) {
          const parentOption = options.find((i) => i.id === option.parent_id);
          parentOption.setPair(option);

          return acc;
        }

        return [...acc, option];
      }, [])
      .sort((a, b) => a.id - b.id);
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
